import { useState } from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import { motion, AnimatePresence } from 'framer-motion'
import { Header } from '@/components/navigation/Header'
import { Sidebar } from '@/components/navigation/Sidebar'
import { MobileNav } from '@/components/navigation/MobileNav'
import { useAuth } from '@/components/layout/AuthProvider'
import { cn } from '@/lib/utils/cn'

export function AppShell() {
  const [sidebarOpen, setSidebarOpen] = useState(false)
  const { user } = useAuth()
  const location = useLocation()

  return (
    <div className="min-h-screen bg-background">
      <Header user={user} onMenuToggle={() => setSidebarOpen(v => !v)} />
      <div className="flex pt-14">
        <aside className="hidden lg:flex lg:flex-col lg:fixed lg:inset-y-14 lg:w-[244px] lg:border-r lg:border-border sidebar-ig overflow-y-auto scrollbar-thin z-header">
          <Sidebar user={user} onClose={() => {}} />
        </aside>
        <AnimatePresence>
          {sidebarOpen && (
            <>
              <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
                transition={{ duration: 0.2 }}
                className="fixed inset-0 bg-black/70 z-drawer lg:hidden"
                onClick={() => setSidebarOpen(false)} />
              <motion.aside
                initial={{ x: '-100%' }} animate={{ x: 0 }} exit={{ x: '-100%' }}
                transition={{ type: 'spring', damping: 30, stiffness: 300 }}
                className="fixed inset-y-0 left-0 w-[280px] sidebar-ig border-r border-border z-drawer overflow-y-auto scrollbar-thin lg:hidden">
                <div className="p-4 border-b border-border flex items-center gap-2">
                  <span className="font-bold text-lg">squids</span>
                  <button onClick={() => setSidebarOpen(false)} className="ml-auto text-text-muted" aria-label="Close">
                    <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" /></svg>
                  </button>
                </div>
                <Sidebar user={user} onClose={() => setSidebarOpen(false)} />
              </motion.aside>
            </>
          )}
        </AnimatePresence>
        <main className={cn("flex-1 min-w-0", "lg:ml-[244px]")}>
          <AnimatePresence mode="wait">
            <motion.div key={location.pathname}
              initial={{ opacity: 0, y: 4 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0 }}
              transition={{ duration: 0.18, ease: [0.16, 1, 0.3, 1] }}
              className="min-h-[calc(100dvh-3.5rem)]">
              <Outlet />
            </motion.div>
          </AnimatePresence>
        </main>
      </div>
      <MobileNav user={user} />
    </div>
  )
}